export const getPinotNoirFranceData = () => ({
  name: "Pinot Noir",
  country: "France",
  description: "Le Pinot Noir est principalement cultivé en Bourgogne, où il produit les vins rouges les plus prestigieux.",
  regions: [
    { name: "Côte de Nuits", area: "3,500 ha", percentage: "40%", description: "Grands crus prestigieux" },
    { name: "Côte de Beaune", area: "2,800 ha", percentage: "32%", description: "Vins d'assemblage" },
    { name: "Côte Chalonnaise", area: "1,500 ha", percentage: "17%", description: "Vins de terroir" },
    { name: "Chablis", area: "800 ha", percentage: "9%", description: "Usage limité" },
    { name: "Autres", area: "200 ha", percentage: "2%", description: "Dispersé en Bourgogne" }
  ],
  mapAreas: [
    { region: "Côte de Nuits", x: 55, y: 35, color: "#4B164C", size: 6 },
    { region: "Côte de Beaune", x: 54, y: 38, color: "#6d2c7a", size: 5 },
    { region: "Côte Chalonnaise", x: 53, y: 42, color: "#8a4a8a", size: 4 },
    { region: "Chablis", x: 58, y: 30, color: "#a768a6", size: 3 }
  ],
  subregions: {
    bourgogne: {
      name: "Bourgogne",
      description: "Le Pinot Noir de Bourgogne est l'expression la plus pure et la plus complexe de ce cépage.",
      characteristics: {
        aromas: "Fruits rouges, sous-bois, truffe, notes minérales",
        body: "Corps léger à moyen",
        tannins: "Tannins fins et soyeux",
        aging: "Excellent potentiel (10-30 ans)"
      },
      terroir: {
        climate: "Climat continental tempéré",
        soil: "Sols calcaires et argilo-calcaires",
        viticulture: "Rendements très limités, vendanges manuelles"
      },
      differentiators: [
        "Complexité aromatique exceptionnelle",
        "Finesse et élégance uniques",
        "Expression du terroir très marquée",
        "Équilibre parfait entre fruité et minéralité"
      ],
      foodPairing: "Viandes blanches, volailles, poissons gras, fromages affinés"
    }
  }
}); 